import { v1 as uuidv1 } from 'uuid';

// 获取图片base64格式
const getBase64Image = (img) => {
  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, img.width, img.height);
  const ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
  const dataURL = canvas.toDataURL(`image/${ext}`);
  return dataURL;
};

const getNodeToOriginText = (nodeList, parentNode = '') => {
  let resultArray = [];
  // 获取有效数据，过滤nodeList中 是数学公式内的text节点
  const formatNodeList = Array.from(nodeList).filter(
    (item) =>
      !(
        (item.nodeName === '#text' &&
          item.namespaceURI &&
          item.namespaceURI.indexOf('MathML') === -1) ||
        (item.nodeName === '#text' && item.nodeValue === '\n  ')
      )
  );

  for (let i = 0; i < formatNodeList.length; i++) {
    const item = formatNodeList[i];
    const nextItem = formatNodeList[i + 1];
    const isOriginTextNode = item.nodeName === '#text';
    const isHasChildNodes = item.childNodes.length > 1;
    const isNodeSpan = item.nodeName === 'SPAN';
    const isNodeDiv = item.nodeName === 'DIV';
    // 原始文本节点并且是非数学公式的文本节点
    if (
      (isOriginTextNode && !item.namespaceURI) ||
      (isOriginTextNode && item.namespaceURI.indexOf('MathML') === -1)
    ) {
      // console.log('原始文本节点');
      resultArray.push(item.nodeValue);
      // 针对提问的元素文本节点做扩展
    } else if (
      isHasChildNodes &&
      item.className.indexOf('ask-inner') !== -1 &&
      isNodeSpan
    ) {
      let spanNodeResult = getNodeToOriginText(item.childNodes);
      resultArray.push(spanNodeResult.join(''));
      // 针对回答的元素文本节点做扩展
    } else if (
      isHasChildNodes &&
      item.className.indexOf('ask-inner') !== -1 &&
      !isNodeSpan
    ) {
      resultArray.push(item.innerText);
    } else if (
      item.nodeName === 'SPAN' &&
      item.className.indexOf('mathtex-block') !== -1
    ) {
      const customLatex = item.getAttribute('data-origin-latex');
      resultArray.push(`$$${decodeURIComponent(customLatex)}$$`);
      // 回复答案中的内容
    } else if (isNodeDiv && item.className.indexOf('ask-inner') !== -1) {
      resultArray.push(item.innerText);
      // 如果是数学公式的一部分
    } else if (
      item.namespaceURI &&
      item.namespaceURI.indexOf('MathML') !== -1
    ) {
      // console.log('数学公式的一部分', item.parentNode);
      // 最后一项是数学公式的一部分
      if (!nextItem) {
        console.warn('最后一块是数学公式');
        const customLatex = parentNode.getAttribute('data-origin-latex');
        resultArray.push(`$$${decodeURIComponent(customLatex)}$$`);
      }
    } else {
      // console.log('其他节点', item, item.childNodes);
      let otherNode = getNodeToOriginText(item.childNodes);
      resultArray.push(otherNode.join(''));
    }
  }

  let joinLineArray = resultArray.map((item) => {
    if (item) {
      return item;
    } else {
      return '\n';
    }
  });
  return joinLineArray;
};

// 获取数学标签根节点
const getRootNode = (node) => {
  if (node.namespaceURI && node.namespaceURI.indexOf('MathML') !== -1) {
    return getRootNode(node.parentNode);
  }
  return node;
};

// 获取划选的内容
const getGptSelectionValue = () => {
  const selected = window.getSelection();
  // 未选中内容时直接返回
  if (selected.type === 'None' || selected.type === 'Caret') return '';
  // 起始点和结束点相同时直接返回
  if (selected.isCollapsed) return '';
  let copyTextArray = [];
  // 获取rangeCount数量 有内容时处理
  if (selected.rangeCount > 0) {
    let range = selected.getRangeAt(0);
    let fragment = range.cloneContents();
    let parentElement = range.commonAncestorContainer;

    // 如果选中内容跨越多个元素，则 commonAncestorContainer 可能会返回 Text 节点，
    // 所以我们需要确保获取到其父元素
    if (parentElement.nodeType !== Node.ELEMENT_NODE) {
      parentElement = parentElement.parentNode;
    }

    // 获取元素最近的根节点
    const rootNode = getRootNode(parentElement);

    // 现在你可以遍历 fragment 中的所有节点
    let childNodes = fragment.childNodes;

    copyTextArray = getNodeToOriginText(childNodes, rootNode);
  }
  return copyTextArray;
};

const commonCopyText = (textToCopy) => {
  const copys = Object.keys(localStorage).filter((item) => {
    return item.startsWith('copy');
  });
  copys.forEach((key) => {
    localStorage.removeItem(key);
  });
  const textarea = document.createElement('textarea');
  const uid = `copy-${uuidv1()}`;
  localStorage.setItem(uid, textToCopy);
  textarea.value = uid;
  textarea.style.position = 'fixed';
  textarea.style.top = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  console.log('复制成功');
};

const addCopyCallback = (e) => {
  // e.preventDefault();
  const selectionText = getGptSelectionValue();
  if (!selectionText) return;
  commonCopyText(selectionText.join(''));
};

const splitIndicatorIntro = (text) => {
  const results = [];
  let str = '';
  const len = text.length;
  for (let i = 0; i < len; i++) {
    const content = text[i];
    if (['（', '）'].includes(content)) {
      if (content === '（') {
        results.push(str);
        str = '（';
      } else {
        str += '）';
        results.push(str);
        str = '';
      }
    } else {
      str += content;
    }
  }
  return results;
};

const isJsonString = (str) => {
  try {
    const parsed = JSON.parse(str);
    const type = Object.prototype.toString.call(parsed);
    if (type !== '[object Object]' && type !== '[object Array]') {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
};

export {
  getBase64Image,
  getGptSelectionValue,
  commonCopyText,
  addCopyCallback,
  splitIndicatorIntro,
  isJsonString
};
